'use strict'

import Helper from '@/utils/helper'

class State {
  constructor ({ id, title, animationType, soundType }) {
    Helper.checkNonNegativeInt('State.id', id)
    Helper.checkString('State.title', title)

    this.id = id
    this.title = title
    this.animationType = animationType
    this.soundType = soundType
  }

  getId () {
    return this.id
  }

  getTitle () {
    return this.title
  }

  getAnimationType () {
    return this.animationType
  }

  getSoundType () {
    return this.soundType
  }
}

export default State
